<template>
  <div class="container">
    <div class="searchBox">
      <div class="type-tabs">
        <el-radio-group v-model="logType" size="small" @change="searchLists">
          <el-radio-button label="part">兼职司机</el-radio-button>
          <el-radio-button label="single">按单司机</el-radio-button>
        </el-radio-group>
      </div>
      <el-form ref="search_data" :model="search_data" size="medium" label-width="150px">
        <div>
          <el-form-item label="司机手机号">
            <el-input v-model="search_data.driver_phone" placeholder="请输入手机号" maxlength="11" style="width: 220px" @keyup.enter.native="searchLists" />
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model="search_time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="timeChange"
              style="width: 360px"
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item label-width="150px">
            <el-button type="primary" icon="el-icon-search" @click="searchLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show">
              {{ progress_show ? '导出中...' : '导出' }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div v-if="progress_show" style="width: 500px; margin: 10px auto;">
      <el-progress :percentage="progress_data"></el-progress>
      <i class="el-icon-loading"></i>
      正在导出...
    </div>

    <div class="searchInfo">
      <el-table :data="tableData" style="width: 100%" header-cell-class-name="table-header">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="driver_name" label="司机姓名" min-width="120" />
        <el-table-column prop="driver_phone" label="司机手机号" min-width="140" />
        <!-- <el-table-column prop="city.name" label="城市" min-width="160" /> -->
        <el-table-column prop="order_code" label="订单号" min-width="200" />
        <el-table-column prop="amount" label="扣费金额" min-width="100" />
        <!-- <el-table-column prop="surplus" label="剩余金额" width="110" /> -->
        <el-table-column prop="trigger_type.alias" label="扣费时机" min-width="120" />
        <el-table-column prop="status.alias" label="状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status && scope.row.status.val == 1 ? 'success' : 'danger'">
              {{ scope.row.status && scope.row.status.alias }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="fail_reason" label="失败原因" min-width="180" />
        <el-table-column prop="created_at" label="创建时间" min-width="160" />
      </el-table>

      <div class="pagination">
        <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function" />
      </div>
    </div>
  </div>
</template>

<script>
var _this;
export default {
  data() {
    return {
      search_time: '',
      logType: 'part',
      tableData: [],
      result_data: [],
      excelData: [],
      progress_show: false,
      progress_data: 0,
      search_data: {
        page: 1,
        limit: 10,
        driver_phone: '',
        fixed_time: '',
      },
      search_rules: {
        page: {
          placeholder: '页码',
          rules: { required: true, message: '页码需要大于0', regulation: 'gt', rulesData: 0 }
        },
        limit: {
          placeholder: '每页个数',
          rules: { required: true, message: '每页个数需在1-51之内', regulation: 'between', rulesData: [1, 51] }
        }
      }
    };
  },
  created() {
    _this = this;
    this.searchLists();
  },
  methods: {
    timeChange(val) {
      this.search_data.fixed_time = val ? JSON.stringify(['between'].concat(val)) : '';
    },
    searchLists() {
      this.search_data.page = 1;
      this.loadLists();
    },
    loadLists() {
      const postData = {
        page: this.search_data.page,
        limit: this.search_data.limit,
        driver_phone: this.search_data.driver_phone || '',
        fixed_time: this.search_data.fixed_time || '',
      };
      const apiMap = {
        single: '/city_insurance/singleLogLists',
        part: '/city_insurance/partLogLists',
      };
      this.$post(apiMap[this.logType] || apiMap.single, postData, this.search_rules)
        .then((res) => {
          this.tableData = (res.data && res.data.result) || [];
          this.result_data = res.data || {};
        })
        .catch((err) => {
          this.$message.error(err && err.msg ? err.msg : '加载失败');
        });
    },
    pages_function(search_data) {
      this.search_data = search_data;
      this.loadLists();
    },
    refresh() {
      this.search_time = '';
      this.logType = 'part';
      this.search_data = {
        page: 1,
        limit: 10,
        driver_phone: '',
        fixed_time: '',
      };
      this.loadLists();
    },
    toExport() {
      this.progress_show = true;
      this.progress_data = 0;
      this.excelData = [];
      const exportSearch = {
        ...this.search_data,
        page: 1,
        limit: 50,
      };
      this.getExcelData(exportSearch);
    },
    getExcelData(searchData) {
      const apiMap = {
        single: '/city_insurance/singleLogLists',
        part: '/city_insurance/partLogLists',
      };
      this.$post(apiMap[this.logType] || apiMap.single, searchData, this.search_rules)
        .then((res) => {
          const list = (res.data && res.data.result) || [];
          list.forEach((item) => {
            this.excelData.push({
              id: item.id,
              driver_name: item.driver_name,
              driver_phone: item.driver_phone,
              order_code: item.order_code,
              amount: item.amount,
              trigger_type: item.trigger_type && item.trigger_type.alias,
              status: item.status && item.status.alias,
              fail_reason: item.fail_reason,
              created_at: item.created_at,
            });
          });

          const total = Number((res.data && res.data.count) || 0);
          const page = Number((res.data && res.data.page) || 1);
          const limit = Number((res.data && res.data.limit) || 50);

          if (page * limit < total) {
            searchData.page = page + 1;
            this.progress_data = Math.floor(((page * limit) / total) * 100);
            this.getExcelData(searchData);
          } else {
            this.exportData();
            this.progress_show = false;
            this.progress_data = 0;
            this.excelData = [];
          }
        })
        .catch(() => {
          this.progress_show = false;
          this.progress_data = 0;
        });
    },
    exportData() {
      const { export_json_to_excel } = require('@/vendor/Export2Excel');
      const tHeader = ['ID', '司机姓名', '司机手机号', '订单号', '扣费金额', '扣费时机', '状态', '失败原因', '创建时间'];
      const filterVal = ['id', 'driver_name', 'driver_phone', 'order_code', 'amount', 'trigger_type', 'status', 'fail_reason', 'created_at'];
      const data = this.formatJson(filterVal, this.excelData);
      const fileName = this.logType === 'single' ? '按单司机保险扣费明细' : '兼职司机保险扣费明细';
      export_json_to_excel(tHeader, data, fileName);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
  background: #f4f7fb;
}
.searchBox {
  background: #fff;
  padding: 18px 18px 8px;
  border: 1px solid #e8edf5;
  border-radius: 12px;
  margin-bottom: 18px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.03);
}
.type-tabs {
  margin-bottom: 16px;
}
.type-tabs /deep/ .el-radio-group {
  display: inline-flex;
  background: #f3f7ff;
  border: 1px solid #e4ecff;
  border-radius: 10px;
  padding: 4px;
}
.type-tabs /deep/ .el-radio-button__inner {
  border: none;
  background: transparent;
  color: #61708a;
  border-radius: 8px !important;
  padding: 9px 18px;
  font-weight: 600;
  transition: all 0.2s ease;
}
.type-tabs /deep/ .el-radio-button.is-active .el-radio-button__inner {
  background: linear-gradient(135deg, #05c0ab 0%, #0dcdb5 100%);
  color: #fff;
  box-shadow: 0 6px 12px rgba(5, 192, 171, 0.18);
}
.searchBox /deep/ .el-form {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.searchBox /deep/ .el-form > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
}
.searchBox /deep/ .el-form-item {
  margin-bottom: 12px;
}
.searchBox /deep/ .el-form-item__label {
  color: #475569;
  font-weight: 700;
}
.searchBox /deep/ .el-input__inner,
.searchBox /deep/ .el-date-editor .el-input__inner {
  height: 36px;
  border-radius: 8px;
  border: 1px solid #dfe7f4;
  background: #fff;
  color: #1f2937;
}
.searchBox /deep/ .el-input__inner:focus,
.searchBox /deep/ .el-date-editor .el-input__inner:focus {
  border-color: #7bb8ff;
  box-shadow: 0 0 0 2px rgba(123, 184, 255, 0.12);
}
.searchBox /deep/ .el-button {
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 600;
}
.searchBox /deep/ .el-button--primary {
  background: linear-gradient(135deg, #05c0ab 0%, #0dcdb5 100%);
  border: none;
  box-shadow: 0 6px 14px rgba(5, 192, 171, 0.16);
}
.searchBox /deep/ .el-button--primary:hover,
.searchBox /deep/ .el-button--primary:focus {
  background: linear-gradient(135deg, #04ae9d 0%, #0fc5b7 100%);
  border-color: transparent;
}
.searchBox /deep/ .el-button--default {
  color: #465a75;
  background: #fff;
  border: 1px solid #dfe7f4;
}
.searchInfo {
  background: #fff;
  border: 1px solid #e8edf5;
  border-radius: 12px;
  padding: 14px 16px 10px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.02);
}
.searchInfo /deep/ .table-header {
  background: #f5f8ff !important;
  color: #1f2d3d !important;
  font-weight: 700;
}
.searchInfo /deep/ .el-table {
  border: 1px solid #edf2f8;
  border-radius: 8px;
  overflow: hidden;
}
.searchInfo /deep/ .el-table th,
.searchInfo /deep/ .el-table td {
  border-color: #edf2f8;
}
.searchInfo /deep/ .el-table__body tr:hover > td {
  background-color: #f6faff !important;
}
.searchInfo /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafcff;
}
.searchInfo /deep/ .el-tag {
  border: none;
  padding: 0 15px;
  /* line-height: 24px; */
  border-radius: 15px;
  font-weight: 600;
}
.searchInfo /deep/ .el-tag--success {
  background: #eafaf0;
  color: #17a058;
}
.searchInfo /deep/ .el-tag--danger {
  background: #fff1f0;
  color: #d56161;
}
.pagination {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
}
</style>
